
import React, { useEffect, useState, useRef } from 'react';
import DataTable from "react-data-table-component";
import axios from 'axios';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import Navbar from '../NavBar/Navbar';
import MapDashboard from '../myproporties/MapDashboard';
import FadeLoader from "react-spinners/FadeLoader";
import StatusDropdown from '../MyWorklist/StatusDropdown'
import { BiSortAlt2 } from "react-icons/bi";
import Popover from '@mui/material/Popover';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';
import HandymanOutlinedIcon from '@mui/icons-material/HandymanOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';

import { useUser } from "../utils/UserContext.jsx"; // Import the custom hook
import { useLocation } from "react-router-dom";
import { fetchParkingOverview } from '../../Services/userService';
import Vector2 from '../../Images/Vector2.svg';

const ViewPrakingLotInfo = (EmailId) => {
  const [anchorEl, setAnchorEl] = useState(null);  // State to track anchor element for the popup
  const [selectedRowData, setSelectedRowData] = useState(null);
  const hostPath = process.env.REACT_APP_API_BASE_URL;
  const hostHeader = process.env.REACT_APP_CUSTOM_HEADER;
  const [parkingLotBookingDetails, setParkingLotBookingDetails] = useState([]);
  const [filter, setFilter] = useState([]);
  const [search, setSearch] = useState("");
  const [, setPopupVisible] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [rowData, setRowData] = useState([]);
  const [areasmarked, setAreasmarked] = useState([]);
  const [isEdit, setEdit] = useState();
  const [parkinglotObj, setparkinglotObj] = useState();
  const [loader, setLoader] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(''); // This will store the selected status
  const [sortDirection, setSortDirection] = useState('asc'); // State for sorting direction
  const [editOption, setEditoption] = useState();
  const [editMenuAnchorEl, setEditMenuAnchorEl] = useState(null);
  const [addProperty, setAddproperty] = useState(false);
  const [mapVisibleChanges, setMapVisibleChanges] = useState(false);
  const { userDetails, employeeData } = useUser();
  const [userData] = useState(userDetails);
  const [defaultaddress, setDefaultaddress] = useState("");
  const [entityId, setEntityId] = useState(null);
  const [empRegistrationId, setEmpRegistrationId] = useState(null)
  const [isEmployee, setIsEmployee] = useState(false);

  const entityIdRef = useRef(null);


  const fetchParkinglotDetails = async () => {
    const id = entityIdRef.current;
    if (!id) return;

    setLoader(true);
    try {
      const body = isEmployee
        ? { EmpRegistrationID: id }
        : { EntityRegistrationID: id };

      const response = await fetch(
        `${hostPath}/api/ParkingLotBookingDetailsbyId`,
        {
          method: "POST",
          headers: {
            "x-functions-key": hostHeader,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const data = await response.json();
      setParkingLotBookingDetails(data);
      setFilter(data);
    } catch (err) {
      console.error("Fetch failed:", err);
      setParkingLotBookingDetails([]);
      setFilter([]);
    } finally {
      setLoader(false);
    }
  };

  const location = useLocation();
  const lotNameFromDashboard = location.state?.lotName;

  useEffect(() => {
    if (!lotNameFromDashboard) return;
    if (!parkingLotBookingDetails.length) return;

    const matchedLot = parkingLotBookingDetails.find(
      (lot) =>
        lot.nickName?.toLowerCase().trim() ===
        lotNameFromDashboard?.toLowerCase().trim()
    );

    if (matchedLot) {
      handleEdittomap(matchedLot); // 🔥 reuse existing logic
    }
  }, [parkingLotBookingDetails, lotNameFromDashboard]);

  useEffect(() => {
    if (isEmployee && empRegistrationId) {
      entityIdRef.current = empRegistrationId;
    } else if (!isEmployee && entityId) {
      entityIdRef.current = entityId;
    }
  }, [isEmployee, entityId, empRegistrationId]);

  useEffect(() => {
    let result = parkingLotBookingDetails;

    if (search) {
      result = result.filter((item) =>
        (item.parkingLotAddress || "")
          .toLowerCase()
          .includes(search.toLowerCase())
      );
    }
    setFilter(result);
  }, [search, parkingLotBookingDetails]);

  useEffect(() => {
    if (userDetails) {
      setIsEmployee(false);
      setEntityId(userDetails.entityRegistrationID);
      setEmpRegistrationId(null);
      setDefaultaddress(userDetails.enityMailingAdderess);
    } else if (employeeData) {
      setIsEmployee(true);
      setEntityId(employeeData.entityRegistrationID);
      setEmpRegistrationId(employeeData.empRegistrationID);
      setDefaultaddress(employeeData.enityMailingAdderess);
    } else {
      setIsEmployee(false);
      setEntityId(null);
      setEmpRegistrationId(null);
      setDefaultaddress("");
    }
  }, [userDetails, employeeData]);

  useEffect(() => {
    if (!hostPath || !entityIdRef.current) return;
    fetchParkinglotDetails();
  }, [isEmployee, entityId, empRegistrationId, hostPath]);

  useEffect(() => {
    let result = parkingLotBookingDetails;

    // Filter by search query
    if (search) {
      result = result.filter((item) => {
        return (item.parkingLotAddress || item.createdDate || item.nickName).toLowerCase().includes(search.toLowerCase());
      });
    }
    // Filter by selected status
    if (selectedStatus.length > 0) {
      result = result.filter((item) => selectedStatus.includes(item.status));
    }
    setFilter(result);
  }, [search, parkingLotBookingDetails, selectedStatus]);
  const handleDelete = (val, typeOfButton) => {
    let message;
    let message2;
    let status;
    if (typeOfButton === 'trash') {
      message = 'Are you sure you want to delete this property? This action is irreversible.';
      message2 = 'Once you proceed, you will not be able to undo this action. Please confirm if you wish to continue.'
      status = 'delete';
    } else if (typeOfButton === 'cancel') {
      message = 'Are you sure you want to mark this property as inactive?';
      message2 = 'You can make it active again in the future if you wish. Please confirm if you wish to continue.'
      status = 'Inactive'
    }
    else if (typeOfButton === 'active') {
      message = 'Are you sure you want to mark this property as active?';
      message2 = 'Please confirm if you wish to continue.'
      status = 'Submitted'
    }

    let data = { EmailId: val.emailId, Parking_Lot_ID: val.parking_Lot_ID, message, message2, status, val };
    setRowData(data);
    setOpen(true);
    setPopupVisible(false);
  };
  const handleConfirm = (text, status, val) => {

    if (text === 'confirm') {

      if (status === 'delete') {
        const requestOptions = {
          method: 'POST',
          headers: { "x-functions-key": hostHeader },
          body: JSON.stringify(rowData)
        };
        setLoader(true);

        axios.post(`${hostPath}/api/DeleteParkingLotDetailsByEmailId`, requestOptions.body, { headers: requestOptions.headers })
          .then(response => {
            if (response.data) {
              if (response.data.status) {
                const newdata = parkingLotBookingDetails.filter((item) => item.parking_Lot_ID !== rowData.Parking_Lot_ID);
                setParkingLotBookingDetails(newdata);
                setFilter(newdata);
                setOpen(false);
              }
              else {
                alert(response.data.responseMessage);
              }
            }
          })
          .catch(error => {
            console.error('Error:', error);
          })
          .finally(() => {
            setLoader(false);
          })
      }
      else if (status === 'Inactive' || status === 'Submitted') {
        let statusval = status;
        if (status === 'Submitted') {
          if (val?.verifyStatus === "Active" || val?.verifyStatus === "Rejected") {
            statusval = val?.verifyStatus
          }
        }
        const CoardinateDetails = val?.coardinateDetails;
        const Scheduleavailability = val?.scheduleavailability
        const parkinglot = {
          "EmailId": val.emailId,
          "EntityRegistrationID": val?.entityRegistrationID,
          "EmpRegistrationID": val?.empRegistrationId || val?.empRegistrationID || val?.EmpRegistrationID,
          "ParkingLotAddress": val?.parkingLotAddress,
          "Parking_Lot_ID": val?.parking_Lot_ID,
          "id": val?.id,
          "CreatedDate": val?.createdDate,
          "Status": statusval,
          "Comment": val?.comment,
          "StreetName": val?.streetName,
          "VerifyStatus": val?.verifyStatus,
          "BankDetailID": val?.bankDetailID,
          "Nickname": val?.nickName,
          "EmpId": val?.empId || val?.EmpId || 0,
          "CreatedBy": val?.createdBy || val?.CreatedBy,
          CoardinateDetails,
          Scheduleavailability
        };
        axios.post(`${hostPath}/api/UpdateParkingLotDetails`, parkinglot, {
          headers: {
            "x-functions-key": hostHeader
          }
        })
          .then(response => {
            if (response.data) {
              fetchParkinglotDetails();
              setOpen(false);
            }
          })
          .catch(error => {
            console.error('Error:', error);
          });
      }
    }
    else if (text === 'cancel') {
      setOpen(false);
    }
  };

  const handleEdit = (e, val) => {
    setSelectedRowData(val);
    setAnchorEl(e.currentTarget);  // Set the clicked element as the anchor for the popup
  };

  const handleEditSubmenuOpen = (e) => {
    e.stopPropagation();
    setEditMenuAnchorEl(e.currentTarget);
  };

  const handleEdittomap = (val) => {
    console.log("valTest", val);

    setparkinglotObj(val);
    setDefaultaddress(val?.parkingLotAddress);

    /* ----------------------------------------------------
       🔹 BUILD GROUP → NORMALIZED SCHEDULE MAP
    ---------------------------------------------------- */
    const groupScheduleMap = {};

    (val?.groupSchedules || []).forEach((group) => {
      const groupName = group.groupName || "Default";

      groupScheduleMap[groupName] = (group.schedules || []).map((sch) => ({
        id: sch.id,
        title: sch.title,
        allDay: sch.allDay || false,
        recurrence: sch.recurrence,
        customRecurrenceCount: sch.customRecurrenceCount || 0,

        // ✅ Normalize dates (VERY IMPORTANT)
        start: sch.start ? new Date(sch.start) : null,
        end: sch.end ? new Date(sch.end) : null,
        endType: sch.endType,
        endDateOn: sch.endDateOn ? new Date(sch.endDateOn) : null,
        endAfter: sch.endAfter,

        // ✅ Inject groupName (missing earlier)
        groupName,

        isMaster: sch.isMaster ?? true,
        isActive: sch.isActive ?? true,
      }));
    });

    /* ----------------------------------------------------
       🔹 TRANSFORM PSLs + ATTACH GROUP SCHEDULES
    ---------------------------------------------------- */
    const transformedAreas = (val?.coardinateDetails || []).map((details) => {
      const groupName =
        Array.isArray(details?.groupName)
          ? details.groupName[0]
          : details?.groupName || "Default";

      return {
        Coordinates: {
          Title: details?.title || "PSL - Parking Space Location",
          Latitude: parseFloat(details?.latitude) || 0,
          Longitude: parseFloat(details?.longitude) || 0,
        },
        Name: details?.title || "PSL - Parking Space Location",
        id: parseInt(details?.id, 10) || Date.now(),
        VehicleSpotSize: details?.vechileSpotSize || "",
        pslName: details?.pslName || "",
        groupName,
        RobotaxiSessionStatus: details?.robotaxiSessionStatus || details?.RobotaxiSessionStatus || "",
        RobotaxiSelectStatus: details?.robotaxiSelectStatus ?? details?.RobotaxiSelectStatus ?? false,

        latandlong: `Latitude: ${parseFloat(details?.latitude) || 0} Longitude: ${parseFloat(details?.longitude) || 0}`,

        // ✅ FINAL: PSL gets schedules from its GROUP
        ScheduleAvailability: groupScheduleMap[groupName] || [],
      };
    });

    console.log("transformedAreasTest", transformedAreas);

    setAreasmarked(transformedAreas);
    setEdit(true);
    setPopupVisible(false);
  };

  const handleStatusChange = (selectedStatus) => {
    setSelectedStatus(selectedStatus);
  };
  const handleSort = (column) => {
    // Toggle the sorting direction
    const newSortDirection = sortDirection === 'asc' ? 'desc' : 'asc';
    setSortDirection(newSortDirection);

    // Sort the data based on the 'createdDate' field
    const sortedData = [...filter].sort((a, b) => {
      const dateA = new Date(a[column]);
      const dateB = new Date(b[column]);

      if (newSortDirection === 'asc') {
        return dateA - dateB;
      } else {
        return dateB - dateA;
      }
    });

    setFilter(sortedData);
  };

  const renderLotStatusBadge = (status) => {
    const label = String(status || "Draft");
    const lower = label.toLowerCase();

    const styleMap = {
      active: {color: "##2E933C",background: "#E4F6E6",display: "inline-flex",padding: "10px 12px",justifyContent: "center",alignItems: "center",gap: "8px",borderRadius: "5px"},
      submitted: { color: "#1565c0", backgroundColor: "#e3f2fd", border: "1px solid #90caf9" },
      draft: { color: "#ef6c00", backgroundColor: "#fff3e0", border: "1px solid #ffcc80" },
      inactive: { color: "#616161", backgroundColor: "#f5f5f5", border: "1px solid #d6d6d6" },
      rejected: { color: "#c62828", backgroundColor: "#fdecea", border: "1px solid #ef9a9a" },
      group: {color: "##0A66C2",background: "#DDEDFD",display: "inline-flex",padding: "10px 12px",justifyContent: "center",alignItems: "center",gap: "8px",borderRadius: "5px"},
      occupied: {color: "##932E2E",background: "#F6E4E4",display: "inline-flex",padding: "10px 12px",justifyContent: "center",alignItems: "center",gap: "8px",borderRadius: "5px"},
      available: {color: "##2E933C",background: "#E4F6E6",display: "inline-flex",padding: "10px 12px",justifyContent: "center",alignItems: "center",gap: "8px",borderRadius: "5px"},
      "not monitored": {color: "##932E2E",background: "#F6E4E4",display: "inline-flex",padding: "10px 12px",justifyContent: "center",alignItems: "center",gap: "8px",borderRadius: "5px"},
    };

    return (
      <span
        style={{
          ...(styleMap[lower] || { color: "#555", backgroundColor: "#f5f5f5", border: "1px solid #ccc" }),
          padding: "3px 10px",
          borderRadius: "12px",
          fontSize: "12px",
          fontWeight: "600",
          display: "inline-block",
          whiteSpace: "nowrap",
          lineHeight: 1.4,
        }}
      >
        {label}
      </span>
    );
  };

  const columns = [
    {
      name: "Nickname",
      selector: (row) => row.nickName,
    },
    {
      name: "Street Address",
      cell: (row) => (
        <div
          style={{ cursor: 'pointer' }}  // Style to indicate it's clickable
          onClick={(e) => handleEdittomap(row)} // Call function when clicked
        >
          {row.parkingLotAddress}
        </div>
      ),
    },
      {
        name: "PSL Type",
        selector: () => "-",
        center: true,
      },
    {
      name: (
        <div style={{ whiteSpace: "normal", textAlign: "center" }}>
          Parking Spaces Selected
        </div>
      ),
      selector: (row) =>
        row?.coardinateDetails?.filter((coord) => coord.title === "PSL - Parking Space Location").length || 0,
      grow: 1,
      wrap: true,
      center: true,
      style: { justifyContent: "center", textAlign: "center" },
    },
    {
      name: (
        <div style={{ whiteSpace: "normal", textAlign: "center",  marginLeft: '40px' }}>
          Created By
        </div>
      ),
      selector: (row) => row?.createdBy,
       style: { justifyContent: "center", textAlign: "center", marginLeft: '5px'},
    },

    {
      name: (
        <div style={{ display: 'flex', alignItems: 'center' }} onClick={() => handleSort('createdDate')}>
          Created Date <BiSortAlt2 style={{ marginLeft: '5px' }} />
        </div>
      ),
      selector: (row) => row.createdDate,
    },
    {
      name: (
        <div style={{ display: 'flex', alignItems: 'center' }} onClick={() => handleSort("lastUpdatedDate")}>
          Last Updated <BiSortAlt2 style={{ marginLeft: '5px' }} />
        </div>
      ),
      selector: (row) => row.lastUpdatedDate,
    },
    {
      name: (
        <div style={{ display: 'flex', alignItems: 'start', marginLeft: '40px' }}>
          <StatusDropdown handleStatusChange={handleStatusChange} />
        </div>
      ),
      cell: (row) => (
        <div style={{ textAlign: "center", marginLeft: '40px' }}>
          {renderLotStatusBadge(row?.status)}
        </div>
      ),
    },
     {
      name: "Actions",
      cell: (row) => (
        <div style={{ textAlign: "center", marginLeft: '5px' }}>
          <IconButton
            size="small"
            aria-label="More actions"
            onClick={(e) => {
              e.stopPropagation();
              handleEdit(e, row);
            }}
          >
            <MoreVertIcon fontSize="small" />
          </IconButton>
        </div>
      ),
    },
  ];

  const handleClose = () => {
    setAnchorEl(null);  // Close the popup
    setEditMenuAnchorEl(null);
  };

  const Isopen = Boolean(anchorEl);  // Boolean to check if the popup is open
  const id = Isopen ? 'edit-popover' : undefined;

  const handleOptionClick = (option) => {
    setEditoption(option);
    setAnchorEl(null);  // Close the popup after selecting an option
    setEditMenuAnchorEl(null);
    handleEdittomap(selectedRowData);
  };
  const handleAddProperty = (val) => {
    setAddproperty(val);
    setEdit(val);
  }
  const handleMapVisibleChanges = (value) => {
    setMapVisibleChanges(value);
  };
  const sessionEntityId = entityIdRef.current || entityId;
  const loggedInUserIdentifier = userDetails?.emailId || employeeData?.emailId;
  const expandedRowsComponentProps = React.useMemo(
    () => ({
      entityId: sessionEntityId,
      hostPath,
      loggedInUserIdentifier,
    }),
    [sessionEntityId, hostPath, loggedInUserIdentifier]
  ); 
   

  return (
    <div>
      {loader && (
        <div className="loader-overlay">
          <FadeLoader />
        </div>
      )}
      <Navbar userData={userData} mapvisible={mapVisibleChanges} setMapvisible={setMapVisibleChanges} />
      {!isEdit ? (

        <div>
          <div className='container-fluid p-0'>
            <div className="lotmanagement">
              <div className="row" style={{ textAlign: "left" }}>
                <div className="col-8">
                  <div className='viewHeader'>Registered Parking Lots</div>
                  <div className='listview'>View the list of parking lots registered</div>
                  {/* <div style={{ color: 'blue', cursor: 'pointer', marginBottom: '15px', fontSize: '16px' }} onClick={navigateToDashboard}>Sign up more parking lots</div> */}
                </div>
              </div>

              <div className="row" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>

                {/* Left side: Total parking lots */}
                <div className="col-6 mb-2" style={{ textAlign: "left" }}>
                  Total parking lots: {parkingLotBookingDetails.length}
                </div>
                {/* Right side: Search input + Add button */}
                <div className="col-6 mb-2" style={{ textAlign: "right", display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "10px" }}>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by address."
                    style={{ maxWidth: "300px" }}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <button className="add-property-btn" onClick={() => handleAddProperty(true)}>
                    Add Property
                  </button>
                </div>
              </div>
              <React.Fragment>
                <DataTable
                  columns={columns}
                  data={filter.length ? filter : []}
                  pagination
                  highlightOnHover
                  fixedHeader
                  selectableRowsHighlight
                  persistTableHead
                  expandableRows
                  expandableRowsComponent={ExpandedGroupsView}
                  expandableRowsComponentProps={expandedRowsComponentProps}
                  expandableIcon={{
                    collapsed: (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "40px",
                          height: "30px",
                          cursor: "pointer",
                        }}
                      >
                        <ExpandMoreIcon style={{ fontSize: "20px", color: "#444" }} />
                      </div>
                    ),
                    expanded: (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "40px",
                          height: "30px",
                          cursor: "pointer",
                        }}
                      >
                        <ExpandLessIcon style={{ fontSize: "20px", color: "#444" }} />
                      </div>
                    ),
                  }}


                  customStyles={{
                    table: {
                      style: {
                        border: "1px solid #e0e0e0",
                        borderRadius: "8px",
                        overflow: "hidden",
                        boxShadow: "0px 1px 3px rgba(0,0,0,0.05)",
                      },
                    },
                    headCells: {
                      style: {
                        backgroundColor: "#f8f8f8",
                        fontWeight: "700",
                        fontSize: "15px",
                        borderBottom: "2px solid #e0e0e0",
                      },
                    },
                    rows: {
                      style: {
                        backgroundColor: "#fff",
                        borderBottom: "1px solid #e0e0e0",
                        minHeight: "60px",
                        transition: "all 0.2s ease",
                      },
                      highlightOnHoverStyle: {
                        backgroundColor: "#fafafa",
                        borderBottomColor: "#ddd",
                        outline: "none",
                      },
                    },
                    cells: {
                      style: {
                        fontSize: "14px",
                        color: "#333",
                        padding: "10px 14px",
                        textAlign: "center",
                      },
                    },
                  }}
                  noDataComponent={<div style={{ padding: 20 }}>No records found</div>}
                />


              </React.Fragment>
            </div>
          </div>
          <Dialog
            classes={{ paper: 'custom-paper-class-delete' }}
            aria-labelledby="customized-dialog-title"
            dividers
            open={open}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <DialogTitle dividers sx={{ textAlign: 'start', color: "#000;", fontSize: "24px", fontWeight: "700", padding: "5px 24px " }} id="customized-dialog-title">
              {rowData?.message}  {/* Display different messages based on the button clicked */}
            </DialogTitle>
            <DialogContent style={{ border: "none", padding: "5px 22px", color: "#000;" }}>
              <Typography gutterBottom>
                <span>{rowData?.message2}</span>
              </Typography>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'right' }}>
              <Button
                className='custom-button-cancel'
                onClick={() => handleConfirm('cancel')}
              >
                Cancel
              </Button>
              <Button
                className='custom-button-delete'
                onClick={() => handleConfirm('confirm', rowData?.status, rowData?.val)}
              >
                Confirm
              </Button>
            </DialogActions>
          </Dialog>

          <Menu
            id={id}
            open={Isopen}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            MenuListProps={{
              sx: { minWidth: 180, padding: '4px 0' },
            }}
          >
            <MenuItem
              onClick={handleEditSubmenuOpen}
              sx={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                fontSize: '14px',
                padding: '8px 12px',
                width: '100%',
                backgroundColor: editMenuAnchorEl ? '#0A66C2' : 'transparent',
                color: editMenuAnchorEl ? '#FFF' : '#000',
                '&:hover': {
                  backgroundColor: '#0A66C2',
                  color: '#FFF'
                }
              }}
            >
              Edit
              <img src={Vector2} alt="submenu" style={{ marginLeft: '18px', width: '7px', height: '11px', filter: editMenuAnchorEl ? 'invert(1)' : 'none' }} />
            </MenuItem>
            <MenuItem
              onClick={(e) => {
                e.stopPropagation();
                handleClose();
                if (selectedRowData?.status === 'Inactive') {
                  handleDelete(selectedRowData, 'active');
                  return;
                }
                if (selectedRowData?.status === 'Active') {
                  handleDelete(selectedRowData, 'cancel');
                }
              }}
              sx={{ 
                fontSize: '14px',
                padding: '8px 12px',
                width: '100%',
                '&:hover': {
                  backgroundColor: '#0A66C2',
                  color: '#FFF'
                }
              }}
            >
              {selectedRowData?.status === 'Inactive' ? 'Activate' : 'Inactive'}
            </MenuItem>
            <MenuItem
              onClick={(e) => {
                e.stopPropagation();
                handleClose();
                handleDelete(selectedRowData, 'trash');
              }}
              sx={{ 
                fontSize: '14px',
                padding: '8px 12px',
                width: '100%',
                '&:hover': {
                  backgroundColor: '#0A66C2',
                  color: '#FFF'
                }
              }}
            >
              Delete
            </MenuItem>
          </Menu>

          <Popover
            open={Boolean(editMenuAnchorEl)}
            anchorEl={editMenuAnchorEl}
            onClose={() => setEditMenuAnchorEl(null)}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            PaperProps={{
              sx: { minWidth: 170, padding: '6px 0' },
            }}
          >
            <div style={{ padding: '0 4px' }}>
              <Button
                variant="text"
                onClick={() => handleOptionClick('parkingspaces')}
                style={{ display: 'block', textAlign: 'left', width: '100%', justifyContent: 'flex-start', textTransform: 'none', color: '#222' }}
              >
                Parking Spaces
              </Button>
              <Button
                variant="text"
                onClick={() => handleOptionClick('parkingschedule')}
                disabled={
                  (selectedRowData?.coardinateDetails?.filter(coord => coord.title === "PSL - Parking Space Location").length || 0) === 0
                }
                style={{ display: 'block', textAlign: 'left', width: '100%', justifyContent: 'flex-start', textTransform: 'none', color: '#222' }}
              >
                Parking Schedule
              </Button>
              <Button
                variant="text"
                onClick={() => handleOptionClick('bankdetails')}
                disabled={
                  (selectedRowData?.coardinateDetails?.filter(coord => coord.title === "PSL - Parking Space Location").length || 0) === 0
                }
                style={{ display: 'block', textAlign: 'left', width: '100%', justifyContent: 'flex-start', textTransform: 'none', color: '#222' }}
              >
                Bank Details
              </Button>
            </div>
          </Popover>


        </div>
      ) : (
        !addProperty ? (
          <div><MapDashboard isEdit={isEdit} areasMarked={areasmarked} defaultaddress={defaultaddress} userData={userDetails} entityId={entityId} employeeData={employeeData} parkinglotObj={parkinglotObj} editOption={editOption} mapVisibleChangesAlert={handleMapVisibleChanges} empRegistrationId={empRegistrationId} isEmployee={isEmployee} groupSchedules={parkinglotObj?.groupSchedules || []} /></div>
        ) : (
          <div><MapDashboard defaultaddress={defaultaddress} userData={userDetails} entityId={entityId} employeeData={employeeData} mapVisibleChangesAlert={handleMapVisibleChanges} isEmployee={isEmployee} empRegistrationId={empRegistrationId} /></div>
        )
      )}
    </div>
  );
};

// ✅ New View Design — identical to OwnerParkinglotRegistration.jsx style
// ✅ Expanded row component — shows Groups → PSLs with session details
const ExpandedGroupsView = ({ data, entityId, hostPath, loggedInUserIdentifier }) => {
  const [expandedGroups, setExpandedGroups] = React.useState({});
  const [expandedPSLs, setExpandedPSLs] = React.useState({});
  const [sessionsByPslKey, setSessionsByPslKey] = React.useState({});
  const [isReportIssueOpen, setIsReportIssueOpen] = React.useState(false);
  const [isEjectRobotaxiOpen, setIsEjectRobotaxiOpen] = React.useState(false);
  const [selectedIssueType, setSelectedIssueType] = React.useState("Damaged Property");
  const [issueNotes, setIssueNotes] = React.useState("");
  const [selectedEjectReason, setSelectedEjectReason] = React.useState("");
  const [selectedEjectTiming, setSelectedEjectTiming] = React.useState("After 10 Minutes");
  const [ejectNotes, setEjectNotes] = React.useState("");
  const [selectedPslNameForEjection, setSelectedPslNameForEjection] = React.useState("");
  const [selectedPslContext, setSelectedPslContext] = React.useState(null);
  const [selectedSessionContext, setSelectedSessionContext] = React.useState(null);
  const [isSubmittingIssue, setIsSubmittingIssue] = React.useState(false);
  const [isSubmittingEjection, setIsSubmittingEjection] = React.useState(false);

  const issueTypes = [
    { label: "Overstayed Session", icon: <AccessTimeOutlinedIcon fontSize="small" /> },
    { label: "Blocked Space", icon: <BlockOutlinedIcon fontSize="small" /> },
    { label: "Damaged Property", icon: <HandymanOutlinedIcon fontSize="small" /> },
    { label: "Other", icon: <DescriptionOutlinedIcon fontSize="small" /> },
  ];

  const ejectReasons = [
    { label: "Overstayed Session", icon: <AccessTimeOutlinedIcon fontSize="small" /> },
    { label: "Space Maintenance Required", icon: <BlockOutlinedIcon fontSize="small" /> },
    { label: "Unauthorized Parking", icon: <HandymanOutlinedIcon fontSize="small" /> },
    { label: "Emergency/Safety issue", icon: <DescriptionOutlinedIcon fontSize="small" /> },
    { label: "Payment Issue", icon: <DescriptionOutlinedIcon fontSize="small" /> },
    { label: "Other (specify below)", icon: <DescriptionOutlinedIcon fontSize="small" /> },
  ];

  const ejectTimings = [
    {
      title: "Eject Immediately",
      subtitle: "Notify robotaxi to leave within 2 minutes",
    },
    {
      title: "After 10 Minutes",
      subtitle: "Give robotaxi 10 minutes grace period",
    },
    {
      title: "After Current Session",
      subtitle: "Allow robotaxi to complete current session",
    },
  ];

  const lotId = data?.parking_Lot_ID ?? null;

  // Extracts the occupiedPSLs array from the API response
  const getOccupiedPSLs = (response) => {
    if (Array.isArray(response)) return response;
    return Array.isArray(response?.occupiedPSLs) ? response.occupiedPSLs : [];
  };

  // Builds a map of { pslId -> session } for fast lookup
  // The API is already scoped per lot, so no additional lot filtering is needed
  const buildPslIdToSessionMap = (response) => {
    const map = {};
    getOccupiedPSLs(response).forEach((session) => {
      const pslId = String(session?.pslId || "").trim();
      if (pslId) map[pslId] = session;
    });
    return map;
  };

  // Returns the active session for a given PSL, or an empty object if none
  const getSessionForPsl = (psl) => {
    const pslId = String(psl.id || "").trim();
    return sessionsByPslKey[pslId] ?? {};
  };

  React.useEffect(() => {
    if (!entityId || !lotId) {
      setSessionsByPslKey({});
      return;
    }

    let isMounted = true;

    const loadSessions = async () => {
      try {
        const response = await fetchParkingOverview(entityId, lotId);
        if (!isMounted) return;
        setSessionsByPslKey(buildPslIdToSessionMap(response));
      } catch (error) {
        console.error("Error fetching sessions for lot:", error);
        if (isMounted) {
          setSessionsByPslKey({});
        }
      }
    };

    loadSessions();

    return () => {
      isMounted = false;
    };
  }, [entityId, lotId]);

  const groupedData = React.useMemo(() => {
    if (!data?.coardinateDetails) return {};
    const groups = {};
    data.coardinateDetails.forEach((coord) => {
      if (coord.title === "PSL - Parking Space Location") {
        const groupName = Array.isArray(coord.groupName)
          ? coord.groupName[0]
          : coord.groupName || "Default";
        if (!groups[groupName]) groups[groupName] = [];
        groups[groupName].push(coord);
      }
    });
    return groups;
  }, [data]);

  const toggleGroup = (group) =>
    setExpandedGroups((prev) => ({ ...prev, [group]: !prev[group] }));

  const togglePSL = (key) =>
    setExpandedPSLs((prev) => ({ ...prev, [key]: !prev[key] }));

  const handleOpenReportIssue = (psl, session = {}) => {
    setSelectedPslContext(psl || null);
    setSelectedSessionContext(session || null);
    setIsReportIssueOpen(true);
  };

  const handleCloseReportIssue = () => {
    setIsReportIssueOpen(false);
  };

  const handleOpenEjectRobotaxi = (psl, session = {}) => {
    setSelectedPslContext(psl || null);
    setSelectedSessionContext(session || null);
    setSelectedPslNameForEjection(psl?.pslName || "-");
    setSelectedEjectReason("");
    setIsEjectRobotaxiOpen(true);
  };

  const handleCloseEjectRobotaxi = () => {
    setIsEjectRobotaxiOpen(false);
  };

  const mapEjectionTimingToApi = (timingTitle) => {
    switch (timingTitle) {
      case "Eject Immediately":
        return "EjectImmediately";
      case "After 10 Minutes":
        return "After10Minutes";
      case "After Current Session":
        return "AfterCurrentSession";
      default:
        return "After10Minutes";
    }
  };

  const getSessionIdFromContext = () => {
    const raw = selectedSessionContext?.sessionId;
    const parsed = Number(raw);
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const getBookingIdFromContext = () => {
    const raw = selectedSessionContext?.bookingId;
    const parsed = Number(raw);
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const handleSubmitIssueReport = async () => {
    if (!hostPath) {
      return;
    }

    const parsedEntityId = Number(entityId);
    const parsedLotId = Number(lotId);

    if (!Number.isFinite(parsedEntityId) || parsedEntityId <= 0) {
      return;
    }

    if (!Number.isFinite(parsedLotId) || parsedLotId <= 0) {
      return;
    }

    const payload = {
      EntityRegistrationID: parsedEntityId,
      LotId: parsedLotId,
      PslId:
        selectedPslContext?.id ??
        null,
      PslName:
        selectedPslContext?.pslName ??
        selectedPslNameForEjection ??
        null,
      IssueType: selectedIssueType,
      AdditionalNotes: issueNotes?.trim() || null,
      ReportedBy: loggedInUserIdentifier || "Owner",
    };

    try {
      setIsSubmittingIssue(true);
      await axios.post(`${hostPath}/api/SubmitIssueReport`, payload);
      setIssueNotes("");
      setSelectedIssueType("Damaged Property");
      setIsReportIssueOpen(false);
    } catch (error) {
      console.error("Error submitting issue report:", error);
    } finally {
      setIsSubmittingIssue(false);
    }
  };

  const handleSubmitEjectionRequest = async () => {
    if (!hostPath) {
      return;
    }

    const parsedLotId = Number(lotId);
    const sessionId = getSessionIdFromContext();
    const bookingId = getBookingIdFromContext();

    if (sessionId <= 0) {
      return;
    }

    if (bookingId <= 0) {
      return;
    }

    if (!Number.isFinite(parsedLotId) || parsedLotId <= 0) {
      return;
    }

    if (!selectedEjectReason) {
      return;
    }

    const payload = {
      SessionId: sessionId,
      BookingId: bookingId,
      LotId: parsedLotId,
      PslId:
        selectedPslContext?.id ??
        null,
      PslName:
        selectedPslContext?.pslName ??
        selectedPslNameForEjection ??
        null,
      IssueType: selectedEjectReason,
      EjectionTiming: mapEjectionTimingToApi(selectedEjectTiming),
      AdditionalNotes: ejectNotes?.trim() || null,
      RequestedBy: loggedInUserIdentifier || "Owner",
    };

    try {
      setIsSubmittingEjection(true);
      await axios.post(`${hostPath}/api/SubmitEjectionRequest`, payload);
      setEjectNotes("");
      setSelectedEjectReason("");
      setSelectedEjectTiming("After 10 Minutes");
      setIsEjectRobotaxiOpen(false);
    } catch (error) {
      console.error("Error submitting ejection request:", error);
    } finally {
      setIsSubmittingEjection(false);
    }
  };

  const getPslStatus = (psl, session = {}) => {
    const robotaxiSelectStatus = psl.robotaxiSelectStatus;
    const sessionStatus = String(session.status ?? "").trim().toLowerCase();

    if (robotaxiSelectStatus === false) {
      return "Not Monitored";
    }

    if (sessionStatus === "sessionstarted") {
      return "Occupied";
    }

    return "Available";
  };

  const StatusBadge = ({ status }) => {
    const lower = (status || "").toLowerCase();
    const styleMap = {
      occupied: { color: "#c62828", backgroundColor: "#fdecea", border: "1px solid #ef9a9a" },
      available: { color: "#2e7d32", backgroundColor: "#e8f5e9", border: "1px solid #a5d6a7" },
      "not monitored": { color: "#bf360c", backgroundColor: "#fbe9e7", border: "1px solid #ffab91" },
    };
    return (
      <span
        style={{
          ...(styleMap[lower] || { color: "#555", backgroundColor: "#f5f5f5", border: "1px solid #ccc" }),
          padding: "3px 10px",
          borderRadius: "12px",
          fontSize: "12px",
          fontWeight: "600",
          display: "inline-block",
          whiteSpace: "nowrap",
        }}
      >
        {status || "Available"}
      </span>
    );
  };

  const rowBase = {
    display: "grid",
    alignItems: "center",
    borderBottom: "1px solid #e0e0e0",
    backgroundColor: "#fff",
    minHeight: "52px",
    padding: "0",
    columnGap: "0px",
    justifyItems: "stretch",
    rowGap: "0px",
  };

  const gridColumns = "24px 20px 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr";

  const cellBase = {
    fontSize: "14px",
    color: "#555",
    padding: "10px 14px",
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  };

  const centerCell = {
    ...cellBase,
    textAlign: "center",
  };

  const iconCell = {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    paddingLeft: "8px",
  };

  return (
    <div style={{ borderTop: "1px solid #e0e0e0" }}>
      {Object.entries(groupedData).map(([groupName, psls]) => (
        <div key={groupName}>
          {/* ── Group Row ── */}
          <div
            onClick={() => toggleGroup(groupName)}
            style={{
              ...rowBase,
              gridTemplateColumns: gridColumns,
              cursor: "pointer",
              backgroundColor: "#f8f9fa",
            }}
          >
            <div />
            <div style={iconCell}>
              {expandedGroups[groupName]
                ? <ExpandLessIcon style={{ fontSize: "16px", color: "#555" }} />
                : <ExpandMoreIcon style={{ fontSize: "16px", color: "#555" }} />}
            </div>
            <div style={{ ...cellBase, fontWeight: "600", color: "#333", paddingLeft: "0px" }}>{groupName}</div>
            <div style={{ ...cellBase, paddingLeft: "4px", whiteSpace: "normal", overflow: "visible", textOverflow: "unset", wordBreak: "break-word" }}>{data.parkingLotAddress || "-"}</div>
            <div style={centerCell}>-</div>
            <div style={centerCell}>{psls.length}</div>
            <div style={centerCell}>{data.createdBy || "-"}</div>
            <div style={centerCell}>{data.createdDate || "-"}</div>
            <div style={centerCell}>{data.lastUpdatedDate || "-"}</div>
            <div style={{ ...centerCell, overflow: "visible" }}>
              <span style={{
                color: "#1565c0",
                backgroundColor: "#e3f2fd",
                border: "1px solid #90caf9",
                padding: "3px 10px",
                borderRadius: "12px",
                fontSize: "12px",
                fontWeight: "600",
                display: "inline-block",
              }}>
                Group
              </span>
            </div>
            <div />
          </div>

          {/* ── PSL Rows under this Group ── */}
          {expandedGroups[groupName] && psls.map((psl, idx) => {
            const pslKey = `${groupName}-${idx}`;
            const session = getSessionForPsl(psl);
            const pslStatus = getPslStatus(psl, session);
            const isExpanded = !!expandedPSLs[pslKey];
            const hasLiveSession = String(session.status ?? "").trim().toLowerCase() === "sessionstarted";

            return (
              <React.Fragment key={pslKey}>
                {/* PSL Row */}
                <div
                  style={{
                    ...rowBase,
                    gridTemplateColumns: gridColumns,
                    cursor: "pointer",
                    backgroundColor: isExpanded ? "#f0f4ff" : "#fafafa",
                  }}
                  onClick={() => togglePSL(pslKey)}
                >
                  <div />
                  <div style={{ ...iconCell, paddingLeft: "28px" }}>
                    {isExpanded
                      ? <ExpandLessIcon style={{ fontSize: "16px", color: "#555" }} />
                      : <ExpandMoreIcon style={{ fontSize: "16px", color: "#555" }} />}
                  </div>
                  <div style={{ ...cellBase, color: "#333", paddingLeft: "0px" }}>{psl.pslName || `PSL ${idx + 1}`}</div>
                  <div style={{ ...cellBase, paddingLeft: "4px", whiteSpace: "normal", overflow: "visible", textOverflow: "unset", wordBreak: "break-word" }}>{data.parkingLotAddress || "-"}</div>
                  <div style={centerCell}>{psl.pslType || "-"}</div>
                  <div style={centerCell}>-</div>
                  <div style={centerCell}>{data.createdBy || "-"}</div>
                  <div style={centerCell}>{data.createdDate || "-"}</div>
                  <div style={centerCell}>{data.lastUpdatedDate || "-"}</div>
                  <div style={{ ...centerCell, overflow: "visible" }}><StatusBadge status={pslStatus} /></div>
                  <div />
                </div>

                {/* ── Expanded PSL Panel ── */}
                {isExpanded && (
                  <div
                    style={{
                      backgroundColor: "#fff",
                      borderBottom: "1px solid #e0e0e0",
                      padding: "16px 24px 16px 168px",
                    }}
                  >
                    {hasLiveSession ? (
                      <div
                        style={{
                          backgroundColor: "#f9f9f9",
                          borderRadius: "8px",
                          border: "1px solid #e0e0e0",
                          padding: "14px 20px",
                        }}
                      >
                        {/* Session Details */}
                        <div
                          style={{
                            display: "flex",
                            gap: "28px",
                            flexWrap: "wrap",
                            alignItems: "center",
                          }}
                        >
                          {[
                            { label: "Robotaxi ID", value: session.robotaxiId || "—" },
                            { label: "Session Duration", value: session.sessionDuration || "—" },
                            { label: "Parking Duration", value: session.parkingDuration || "—" },
                            { label: "Remaining Duration", value: session.remainingDuration || "—" },
                            { label: "Start Time", value: session.formattedStartTime || session.startTime || "—" },
                            {
                              label: "Amount",
                              value:
                                session.amount != null
                                  ? `$${session.amount}`
                                  : "—",
                            },
                          ].map(({ label, value }) => (
                            <div key={label}>
                              <div style={{ fontSize: "11px", color: "#888", fontWeight: "600", textTransform: "uppercase", marginBottom: "2px" }}>
                                {label}
                              </div>
                              <div style={{ fontSize: "14px", fontWeight: "600", color: "#222" }}>
                                {value}
                              </div>
                            </div>
                          ))}
                          <button
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                              padding: "7px 18px",
                              marginLeft: "8px",
                              border: "1.5px solid #555",
                              borderRadius: "6px",
                              backgroundColor: "#fff",
                              cursor: "pointer",
                              fontSize: "13px",
                              fontWeight: "500",
                              color: "#333",
                            }}
                            onClick={() => handleOpenReportIssue(psl, session)}
                          >
                            ⓘ Report Issue
                          </button>
                          <button
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                              padding: "7px 18px",
                              border: "none",
                              borderRadius: "6px",
                              backgroundColor: "#c62828",
                              color: "#fff",
                              cursor: "pointer",
                              fontSize: "13px",
                              fontWeight: "500",
                            }}
                            onClick={() => handleOpenEjectRobotaxi(psl, session)}
                          >
                            ⏏ Eject Robotaxi
                          </button>
                        </div>
                      </div>
                    ) : pslStatus.toLowerCase() === "available" ? (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "10px",
                          padding: "20px",
                          backgroundColor: "#f9f9f9",
                          borderRadius: "8px",
                          border: "1px solid #e0e0e0",
                          color: "#888",
                          fontSize: "14px",
                          fontWeight: "500",
                        }}
                      >
                        <span style={{ fontSize: "20px" }}>🚫</span>
                        No Robotaxi Parked
                      </div>
                    ) : (
                      /* Not Monitored */
                      <div
                        style={{
                          padding: "14px 18px",
                          backgroundColor: "#fff8f3",
                          borderRadius: "8px",
                          border: "1px solid #ffe0b2",
                          color: "#bf360c",
                          fontSize: "14px",
                          fontWeight: "500",
                        }}
                      >
                        This parking space is not currently monitored. No session data available.
                      </div>
                    )}
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </div>
      ))}

      <Dialog
        open={isReportIssueOpen}
        onClose={handleCloseReportIssue}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: 700, fontSize: "22px", paddingBottom: "4px" }}>
          Report Issue
        </DialogTitle>
        <DialogContent sx={{ paddingTop: "4px !important" }}>
          <div style={{ color: "#666", fontSize: "14px", marginBottom: "16px" }}>
            Report a problem with space
          </div>

          <div style={{ fontWeight: 600, fontSize: "14px", marginBottom: "10px" }}>
            Issue Type
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "10px",
              marginBottom: "14px",
            }}
          >
            {issueTypes.map((issue) => {
              const isSelected = selectedIssueType === issue.label;
              return (
                <button
                  key={issue.label}
                  type="button"
                  onClick={() => setSelectedIssueType(issue.label)}
                  style={{
                    border: isSelected ? "2px solid #1976d2" : "1px solid #d0d0d0",
                    backgroundColor: isSelected ? "#f3f8ff" : "#fff",
                    borderRadius: "8px",
                    padding: "12px 8px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "6px",
                    cursor: "pointer",
                    fontSize: "14px",
                    color: "#222",
                    minHeight: "60px",
                  }}
                >
                  <span style={{ color: "#444", display: "flex", alignItems: "center" }}>{issue.icon}</span>
                  {issue.label}
                </button>
              );
            })}
          </div>

          <div style={{ fontWeight: 600, fontSize: "14px", marginBottom: "8px" }}>
            Additional Notes
          </div>
          <textarea
            value={issueNotes}
            onChange={(e) => setIssueNotes(e.target.value)}
            placeholder="Describe the issue in detail.."
            style={{
              width: "100%",
              minHeight: "84px",
              resize: "none",
              border: "1px solid #e0e0e0",
              borderRadius: "6px",
              padding: "10px",
              fontSize: "14px",
              color: "#333",
              boxSizing: "border-box",
              backgroundColor: "#fafafa",
            }}
          />
        </DialogContent>

        <DialogActions sx={{ padding: "14px 24px 18px 24px", justifyContent: "flex-end", gap: "10px" }}>
          <Button
            onClick={handleCloseReportIssue}
            sx={{
              textTransform: "none",
              color: "#333",
              backgroundColor: "#f2f2f2",
              minWidth: "78px",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmitIssueReport}
            variant="contained"
            disabled={isSubmittingIssue}
            sx={{
              textTransform: "none",
              minWidth: "100px",
              backgroundColor: "#1976d2",
            }}
          >
            {isSubmittingIssue ? "Submitting..." : "Submit Report"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={isEjectRobotaxiOpen}
        onClose={handleCloseEjectRobotaxi}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: 700, fontSize: "22px", paddingBottom: "4px" }}>
          Eject Robotaxi
        </DialogTitle>
        <DialogContent sx={{ paddingTop: "4px !important", overflowY: "auto", maxHeight: "60vh" }}>
          <div style={{ color: "#666", fontSize: "14px", marginBottom: "16px" }}>
            Space: {selectedPslNameForEjection} | Please select a reason and timing for ejection
          </div>

          <div style={{ fontWeight: 600, fontSize: "14px", marginBottom: "10px" }}>
            Issue Type
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "10px",
              marginBottom: "14px",
            }}
          >
            {ejectReasons.map((reason) => {
              const isSelected = selectedEjectReason === reason.label;
              return (
                <button
                  key={reason.label}
                  type="button"
                  onClick={() => setSelectedEjectReason(reason.label)}
                  style={{
                    border: isSelected ? "2px solid #1976d2" : "1px solid #d0d0d0",
                    backgroundColor: isSelected ? "#f3f8ff" : "#fff",
                    borderRadius: "8px",
                    padding: "14px 8px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "6px",
                    cursor: "pointer",
                    fontSize: "14px",
                    color: "#222",
                    minHeight: "68px",
                    textAlign: "center",
                  }}
                >
                  <span style={{ color: "#444", display: "flex", alignItems: "center" }}>{reason.icon}</span>
                  {reason.label}
                </button>
              );
            })}
          </div>

          <div style={{ fontWeight: 600, fontSize: "14px", marginBottom: "8px" }}>
            Eject Timing
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginBottom: "14px" }}>
            {ejectTimings.map((timing) => {
              const isSelected = selectedEjectTiming === timing.title;
              return (
                <button
                  key={timing.title}
                  type="button"
                  onClick={() => setSelectedEjectTiming(timing.title)}
                  style={{
                    border: isSelected ? "2px solid #1976d2" : "1px solid #d0d0d0",
                    backgroundColor: isSelected ? "#f3f8ff" : "#fff",
                    borderRadius: "8px",
                    padding: "10px 14px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    justifyContent: "center",
                    cursor: "pointer",
                    textAlign: "left",
                  }}
                >
                  <span style={{ fontSize: "14px", color: "#111", marginBottom: "4px", fontWeight: 500 }}>
                    {timing.title}
                  </span>
                  <span style={{ fontSize: "12px", color: "#777" }}>
                    {timing.subtitle}
                  </span>
                </button>
              );
            })}
          </div>

          <div style={{ fontWeight: 600, fontSize: "14px", marginBottom: "8px" }}>
            Additional Notes (optional)
          </div>
          <textarea
            value={ejectNotes}
            onChange={(e) => setEjectNotes(e.target.value)}
            placeholder="Describe the issue in detail.."
            style={{
              width: "100%",
              minHeight: "84px",
              resize: "none",
              border: "1px solid #e0e0e0",
              borderRadius: "6px",
              padding: "10px",
              fontSize: "14px",
              color: "#333",
              boxSizing: "border-box",
              backgroundColor: "#fafafa",
            }}
          />
        </DialogContent>

        <DialogActions sx={{ padding: "14px 24px 18px 24px", justifyContent: "flex-end", gap: "10px" }}>
          <Button
            onClick={handleCloseEjectRobotaxi}
            sx={{
              textTransform: "none",
              color: "#333",
              backgroundColor: "#f2f2f2",
              minWidth: "78px",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmitEjectionRequest}
            variant="contained"
            disabled={isSubmittingEjection || !selectedEjectReason}
            sx={{
              textTransform: "none",
              minWidth: "120px",
              backgroundColor: "#c62828",
            }}
          >
            {isSubmittingEjection ? "Submitting..." : "Confirm Ejection"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};


export default ViewPrakingLotInfo;
